import { Box, Center, Spinner, type BoxProps } from '@chakra-ui/react';
import type { ReactNode, RefObject } from 'react';

export interface ChatPanelBodyProps extends BoxProps {
  ref?: RefObject<HTMLDivElement | null>;
  loading?: boolean;
  children: ReactNode;
}

function ChatPanelBody({ loading, children, ref, ...props }: ChatPanelBodyProps) {
  return (
    <Box
      ref={ref}
      className="ChatPanelBody"
      pos="relative"
      display="flex"
      flexDirection="column"
      flex="1 1 auto"
      // overflow="auto"
      overflow="hidden"
      background="linear-gradient(0deg, var(--app-bg), var(--app-bg)), var(--app-bg)"
      backgroundPosition="center"
      backgroundRepeat="repeat"
      {...props}
    >
      {loading ? (
        <Center className="ChatPanelBodyLoading" h="full">
          <Spinner size="sm" />
        </Center>
      ) : (
        children
      )}
    </Box>
  );
}

const MemoizedChatPanelBody = memo(ChatPanelBody);

export { MemoizedChatPanelBody as ChatPanelBody };
